import type * as api from '@gitbook/api-client';
import type { Revision } from '@gitbook/hive-core';
import { PaletteButton } from '@gitbook/react-uikit';
import type { ButtonProps } from '@gitbook/spine-react';

import { useRevisionCommands } from './useRevisionCommands';

/**
 * Button to open the revision options palette
 */
export function RevisionOptionsButton(
    props: {
        space: api.Space;
        changeRequest: api.ChangeRequest | null;
        revision: Revision;
        readOnly?: boolean;
    } & Partial<ButtonProps>
) {
    const { space, revision, changeRequest, readOnly = true, ...buttonProps } = props;

    const [palette, rollbackConfirmModal] = useRevisionCommands(space, revision, changeRequest, {
        readOnly,
    });

    return (
        <>
            <PaletteButton label="Revision options" palette={palette} {...buttonProps} />
            {rollbackConfirmModal}
        </>
    );
}
